import React from 'react'
import Footer from './Footer'
import { FaSteam, FaEpic, FaDownload, FaCheckCircle } from 'react-icons/fa'
import { motion } from 'framer-motion'
import SEO from '../components/SEO.jsx';

export default function Installer() {
  const stepVariants = {
    hidden: { opacity: 0, x: -20 },
    visible: (i) => ({ opacity: 1, x: 0, transition: { delay: i * 0.2 } }),
  }

  return (
    <>
      <SEO
        title="Comment installer vos jeux"
        description="Guide pas à pas pour installer vos jeux vidéo digitaux PS4, PS5, Steam et Epic Games après achat sur CodeShop225."
        path="/comment__installer/"
      />
      <div className='container py-12'>
        <motion.div
          className="p-8 max-w-3xl mx-auto bg-white shadow-2xl rounded-3xl space-y-8"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="container install__header">
            Comment installer vos jeux (version digitale)
          </h1>

          <p className="install__header">
            Après votre achat, récupérez votre code ou lien et suivez ces étapes simples pour installer votre jeu.
          </p>

          <ol className="list-decimal list-inside text-gray-700 space-y-6">
            {[
              { icon: <FaSteam className="text-blue-600 w-6 h-6" />, text: "Créez ou connectez-vous à votre compte sur la plateforme correspondante (Steam, Epic Games, Origin, etc.)." },
              { icon: <FaDownload className="text-green-600 w-6 h-6" />, text: "Récupérez votre code ou lien depuis votre email ou whatsApp." },
              { icon: <FaCheckCircle className="text-yellow-500 w-6 h-6" />, text: "Entrez le code dans la plateforme ou cliquez sur le lien pour démarrer le téléchargement." },
              { icon: <FaDownload className="text-purple-500 w-6 h-6" />, text: "Téléchargez et installez le jeu sur votre console." },
              { icon: <FaCheckCircle className="text-green-500 w-6 h-6" />, text: "Lancez le jeu et profitez de votre expérience !" },
            ].map((step, i) => (
              <motion.li
                key={i}
                custom={i}
                initial="hidden"
                animate="visible"
                variants={stepVariants}
                className="install__text"
              >
                {step.icon}
                <span className="install__text">{step.text}</span>
              </motion.li>
            ))}
          </ol>

          <motion.p
            className="install__text"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1.5 }}
          >
            ⚠️ Assurez-vous que votre connexion internet est stable et que vous disposez d’assez d’espace disque avant de commencer le téléchargement.
          </motion.p>

          <motion.p
            className="install__text"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1.8 }}
          >
            Pour toute assistance, contactez notre support via votre espace client.
          </motion.p>
        </motion.div>
      </div>
      <Footer/>
    </>
  )
}